import { render, staticRenderFns } from "./tagViews.vue?vue&type=template&id=6856f479&scoped=true"
import script from "./tagViews.vue?vue&type=script&lang=js"
export * from "./tagViews.vue?vue&type=script&lang=js"
import style0 from "./tagViews.vue?vue&type=style&index=0&id=6856f479&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856f479",
  null
  
)

export default component.exports